const tokens = {
    "components": {
        "button": {
            "border-radius": "var(--hd-button-border-radius)",
            "font-size": "var(--hd-button-font-size)",
            "font-weight": "var(--hd-button-font-weight)",
            "padding": "var(--hd-button-padding)",
            "height": "var(--hd-button-height)",
            "min-width": "var(--hd-button-min-width)",
            "default": {
                "bg-color": "var(--hd-button-bg-color)",
                "color": "var(--hd-button-color)",
                "hover": {
                    "bg-color": "var(--hd-button-hover-bg-color)"
                }
            },
            "danger": {
                "bg-color": "var(--hd-button-danger-bg-color)",
                "color": "var(--hd-button-danger-color)",
                "hover": {
                    "bg-color": "var(--hd-button-danger-hover-bg-color)"
                }
            },
            "disabled": {
                "bg-color": "var(--hd-button-disabled-bg-color)",
                "color": "var(--hd-button-disabled-color)",
                "hover": {
                    "bg-color": "var(--hd-button-disabled-hover-bg-color)"
                }
            },
            "primary": {
                "bg-color": "var(--hd-button-primary-bg-color)",
                "color": "var(--hd-button-primary-color)",
                "hover": {
                    "bg-color": "var(--hd-button-primary-hover-bg-color)"
                }
            },
            "secondary": {
                "bg-color": "var(--hd-button-secondary-bg-color)",
                "color": "var(--hd-button-secondary-color)",
                "hover": {
                    "bg-color": "var(--hd-button-secondary-hover-bg-color)"
                }
            }
        },
        "input": {
            "bg-color": "var(--hd-input-bg-color)",
            "border-radius": "var(--hd-input-border-radius)",
            "color": "var(--hd-input-color)",
            "font-size": "var(--hd-input-font-size)",
            "font-weight": "var(--hd-input-font-weight)",
            "height": "var(--hd-input-height)",
            "padding": "var(--hd-input-padding)",
            "hover": {
                "border-color": "var(--hd-input-hover-border-color)"
            },
            "disabled": {
                "color": "var(--hd-input-disabled-color)"
            },
            "error": {
                "border-color": "var(--hd-input-error-border-color)"
            },
            "description": {
                "color": "var(--hd-input-description-color)",
                "font-size": "var(--hd-input-description-font-size)",
                "error": {
                    "color": "var(--hd-input-description-error-color)"
                }
            },
            "icon": {
                "color": "var(--hd-input-icon-color)"
            },
            "inner-value": {
                "focus": {
                    "bg-color": "var(--hd-input-inner-value-focus-bg-color)",
                    "border-radius": "var(--hd-input-inner-value-focus-border-radius)"
                },
                "font-size": "var(--hd-input-inner-value-font-size)"
            },
            "label": {
                "color": "var(--hd-input-label-color)",
                "font-weight": "var(--hd-input-label-font-weight)",
                "font-size": "var(--hd-input-label-font-size)"
            },
            "placeholder": {
                "color": "var(--hd-input-placeholder-color)",
                "font-weight": "var(--hd-input-placeholder-font-weight)"
            }
        },
        "link": {
            "color": "var(--hd-link-color)",
            "hover": {
                "color": "var(--hd-link-hover-color)"
            }
        },
        "typescale": {
            "color": "var(--hd-typescale-color)",
            "xs": {
                "font-size": "var(--hd-typescale-xs-font-size)",
                "font-weight": "var(--hd-typescale-xs-font-weight)",
                "line-height": "var(--hd-typescale-xs-line-height)"
            },
            "sm": {
                "font-size": "var(--hd-typescale-sm-font-size)",
                "font-weight": "var(--hd-typescale-sm-font-weight)",
                "line-height": "var(--hd-typescale-sm-line-height)"
            },
            "md": {
                "font-size": "var(--hd-typescale-md-font-size)",
                "font-weight": "var(--hd-typescale-md-font-weight)",
                "line-height": "var(--hd-typescale-md-line-height)"
            },
            "lg": {
                "font-size": "var(--hd-typescale-lg-font-size)",
                "font-weight": "var(--hd-typescale-lg-font-weight)",
                "line-height": "var(--hd-typescale-lg-line-height)"
            },
            "xl": {
                "font-size": "var(--hd-typescale-xl-font-size)",
                "font-weight": "var(--hd-typescale-xl-font-weight)",
                "line-height": "var(--hd-typescale-xl-line-height)"
            },
            "xxl": {
                "font-size": "var(--hd-typescale-xxl-font-size)",
                "font-weight": "var(--hd-typescale-xxl-font-weight)",
                "line-height": "var(--hd-typescale-xxl-line-height)"
            }
        },
        "asset": {
            "font": {
                "proxima-nova": {
                    "bold": "var(--hd-asset-font-proxima-nova-bold)",
                    "default": "var(--hd-asset-font-proxima-nova)",
                    "light": "var(--hd-asset-font-proxima-nova-light)",
                    "regular": "var(--hd-asset-font-proxima-nova-regular)",
                    "semibold": "var(--hd-asset-font-proxima-nova-semibold)"
                },
                "root-filepath": "var(--hd-asset-font-root-filepath)"
            }
        }
    },
    "breakpoint": {
        /** A 'mobile-sized' viewport, generally renders on smaller-mid display size phones.*/ "mobile": {
            /** The minimum bound for the mobile responsive breakpoint.*/ "min": "0px",
            /** The maximum bound for the mobile responsive breakpoint.*/ "max": "740px"
        },
        /** A 'table-sized' viewport, generally renders on large display size phones or smaller resolution tablets.*/ "tablet": {
            /** The minimum bound for the tablet responsive breakpoint.*/ "min": "741px",
            /** The maximum bound for the tablet responsive breakpoint.*/ "max": "992px"
        },
        /** A 'desktop-sized' viewport, generally renders on smaller resolution desktops, along with high resolution tablets.*/ "desktop": {
            /** The minimum bound for the desktop responsive breakpoint.*/ "min": "993px",
            /** The maximum bound for the desktop responsive breakpoint.*/ "max": "1200px"
        },
        /** A 'wide-sized' viewport, generally renders on desktops with higher resolutions.*/ "wide": {
            /** The minimum bound for the wide responsive breakpoint.*/ "min": "1201px",
            /** The maximum bound for the wide responsive breakpoint.*/ "max": "9999px"
        }
    },
    "color": {
        /** Accent colors help establish the overall brand look of the app. For example, main action buttons often inherit this color, along with most interactable elements.*/ "accent": {
            /** Base Brand accent color - used most frequently across the interface in combination with UI neutrals.*/ "default": "var(--hd-color-accent)",
            /** Weaker version of accent color. Used often as a background or secondary 'non-highlight' version of the accent color.*/ "weak": "var(--hd-color-accent-weak)"
        },
        "palette": {
            "aqua": {
                /** Color Palette Base Aqua at 5% opacity on white*/ "5": "var(--hd-color-palette-aqua-5)",
                /** Color Palette Base Aqua at 10% opacity on white*/ "10": "var(--hd-color-palette-aqua-10)",
                /** Color Palette Base Aqua at 20% opacity on white*/ "20": "var(--hd-color-palette-aqua-20)",
                /** Color Palette Base Aqua at 30% opacity on white*/ "30": "var(--hd-color-palette-aqua-30)",
                /** Color Palette Base Aqua at 40% opacity on white*/ "40": "var(--hd-color-palette-aqua-40)",
                /** Color Palette Base Aqua at 50% opacity on white*/ "50": "var(--hd-color-palette-aqua-50)",
                /** Color Palette Base Aqua at 60% opacity on white*/ "60": "var(--hd-color-palette-aqua-60)",
                /** Color Palette Base Aqua at 70% opacity on white*/ "70": "var(--hd-color-palette-aqua-70)",
                /** Color Palette Base Aqua at 80% opacity on white*/ "80": "var(--hd-color-palette-aqua-80)",
                /** Color Palette Base Aqua at 90% opacity on white*/ "90": "var(--hd-color-palette-aqua-90)",
                /** Color Palette Base Aqua*/ "100": "var(--hd-color-palette-aqua-100)",
                /** Color Palette Base Aqua with 10% opacity black*/ "110": "var(--hd-color-palette-aqua-110)",
                /** Color Palette Base Aqua with 20% opacity black*/ "120": "var(--hd-color-palette-aqua-120)",
                /** Color Palette Base Aqua with 30% opacity black*/ "130": "var(--hd-color-palette-aqua-130)",
                /** Color Palette Base Aqua with 40% opacity black*/ "140": "var(--hd-color-palette-aqua-140)",
                /** Color Palette Base Aqua with 50% opacity black*/ "150": "var(--hd-color-palette-aqua-150)",
                /** Color Palette Base Aqua with 60% opacity black*/ "160": "var(--hd-color-palette-aqua-160)"
            },
            "blurple": {
                /** Color Palette Base Blurple at 5% opacity on white*/ "5": "var(--hd-color-palette-blurple-5)",
                /** Color Palette Base Blurple at 10% opacity on white*/ "10": "var(--hd-color-palette-blurple-10)",
                /** Color Palette Base Blurple at 20% opacity on white*/ "20": "var(--hd-color-palette-blurple-20)",
                /** Color Palette Base Blurple at 30% opacity on white*/ "30": "var(--hd-color-palette-blurple-30)",
                /** Color Palette Base Blurple at 40% opacity on white*/ "40": "var(--hd-color-palette-blurple-40)",
                /** Color Palette Base Blurple at 50% opacity on white*/ "50": "var(--hd-color-palette-blurple-50)",
                /** Color Palette Base Blurple at 60% opacity on white*/ "60": "var(--hd-color-palette-blurple-60)",
                /** Color Palette Base Blurple at 70% opacity on white*/ "70": "var(--hd-color-palette-blurple-70)",
                /** Color Palette Base Blurple at 80% opacity on white*/ "80": "var(--hd-color-palette-blurple-80)",
                /** Color Palette Base Blurple at 90% opacity on white*/ "90": "var(--hd-color-palette-blurple-90)",
                /** Color Palette Base Blurple*/ "100": "var(--hd-color-palette-blurple-100)",
                /** Color Palette Base Blurple with 10% opacity black*/ "110": "var(--hd-color-palette-blurple-110)",
                /** Color Palette Base Blurple with 20% opacity black*/ "120": "var(--hd-color-palette-blurple-120)",
                /** Color Palette Base Blurple with 30% opacity black*/ "130": "var(--hd-color-palette-blurple-130)",
                /** Color Palette Base Blurple with 40% opacity black*/ "140": "var(--hd-color-palette-blurple-140)",
                /** Color Palette Base Blurple with 50% opacity black*/ "150": "var(--hd-color-palette-blurple-150)",
                /** Color Palette Base Blurple with 60% opacity black*/ "160": "var(--hd-color-palette-blurple-160)"
            },
            "gray": {
                /** Color Palette Base Gray at 5% opacity on white*/ "5": "var(--hd-color-palette-gray-5)",
                /** Color Palette Base Gray at 10% opacity on white*/ "10": "var(--hd-color-palette-gray-10)",
                /** Color Palette Base Gray at 20% opacity on white*/ "20": "var(--hd-color-palette-gray-20)",
                /** Color Palette Base Gray at 30% opacity on white*/ "30": "var(--hd-color-palette-gray-30)",
                /** Color Palette Base Gray at 40% opacity on white*/ "40": "var(--hd-color-palette-gray-40)",
                /** Color Palette Base Gray at 50% opacity on white*/ "50": "var(--hd-color-palette-gray-50)",
                /** Color Palette Base Gray at 60% opacity on white*/ "60": "var(--hd-color-palette-gray-60)",
                /** Color Palette Base Gray at 70% opacity on white*/ "70": "var(--hd-color-palette-gray-70)",
                /** Color Palette Base Gray at 80% opacity on white*/ "80": "var(--hd-color-palette-gray-80)",
                /** Color Palette Base Gray at 90% opacity on white*/ "90": "var(--hd-color-palette-gray-90)",
                /** Color Palette Base Gray*/ "100": "var(--hd-color-palette-gray-100)",
                /** Color Palette Base Gray with 10% opacity black*/ "110": "var(--hd-color-palette-gray-110)",
                /** Color Palette Base Gray with 20% opacity black*/ "120": "var(--hd-color-palette-gray-120)",
                /** Color Palette Base Gray with 30% opacity black*/ "130": "var(--hd-color-palette-gray-130)",
                /** Color Palette Base Gray with 40% opacity black*/ "140": "var(--hd-color-palette-gray-140)",
                /** Color Palette Base Gray with 50% opacity black*/ "150": "var(--hd-color-palette-gray-150)",
                /** Color Palette Base Gray with 60% opacity black*/ "160": "var(--hd-color-palette-gray-160)"
            },
            "green": {
                /** Color Palette Base Green at 5% opacity on white*/ "5": "var(--hd-color-palette-green-5)",
                /** Color Palette Base Green at 10% opacity on white*/ "10": "var(--hd-color-palette-green-10)",
                /** Color Palette Base Green at 20% opacity on white*/ "20": "var(--hd-color-palette-green-20)",
                /** Color Palette Base Green at 30% opacity on white*/ "30": "var(--hd-color-palette-green-30)",
                /** Color Palette Base Green at 40% opacity on white*/ "40": "var(--hd-color-palette-green-40)",
                /** Color Palette Base Green at 50% opacity on white*/ "50": "var(--hd-color-palette-green-50)",
                /** Color Palette Base Green at 60% opacity on white*/ "60": "var(--hd-color-palette-green-60)",
                /** Color Palette Base Green at 70% opacity on white*/ "70": "var(--hd-color-palette-green-70)",
                /** Color Palette Base Green at 80% opacity on white*/ "80": "var(--hd-color-palette-green-80)",
                /** Color Palette Base Green at 90% opacity on white*/ "90": "var(--hd-color-palette-green-90)",
                /** Color Palette Base Green*/ "100": "var(--hd-color-palette-green-100)",
                /** Color Palette Base Green with 10% opacity black*/ "110": "var(--hd-color-palette-green-110)",
                /** Color Palette Base Green with 20% opacity black*/ "120": "var(--hd-color-palette-green-120)",
                /** Color Palette Base Green with 30% opacity black*/ "130": "var(--hd-color-palette-green-130)",
                /** Color Palette Base Green with 40% opacity black*/ "140": "var(--hd-color-palette-green-140)",
                /** Color Palette Base Green with 50% opacity black*/ "150": "var(--hd-color-palette-green-150)",
                /** Color Palette Base Green with 60% opacity black*/ "160": "var(--hd-color-palette-green-160)"
            },
            "purple": {
                /** Color Palette Purple*/ "100": "var(--hd-color-palette-purple-100)"
            },
            "red": {
                /** Color Palette Base Red at 5% opacity on white*/ "5": "var(--hd-color-palette-red-5)",
                /** Color Palette Base Red at 10% opacity on white*/ "10": "var(--hd-color-palette-red-10)",
                /** Color Palette Base Red at 20% opacity on white*/ "20": "var(--hd-color-palette-red-20)",
                /** Color Palette Base Red at 30% opacity on white*/ "30": "var(--hd-color-palette-red-30)",
                /** Color Palette Base Red at 40% opacity on white*/ "40": "var(--hd-color-palette-red-40)",
                /** Color Palette Base Red at 50% opacity on white*/ "50": "var(--hd-color-palette-red-50)",
                /** Color Palette Base Red at 60% opacity on white*/ "60": "var(--hd-color-palette-red-60)",
                /** Color Palette Base Red at 70% opacity on white*/ "70": "var(--hd-color-palette-red-70)",
                /** Color Palette Base Red at 80% opacity on white*/ "80": "var(--hd-color-palette-red-80)",
                /** Color Palette Base Red at 90% opacity on white*/ "90": "var(--hd-color-palette-red-90)",
                /** Color Palette Base Red*/ "100": "var(--hd-color-palette-red-100)",
                /** Color Palette Base Red with 10% opacity black*/ "110": "var(--hd-color-palette-red-110)",
                /** Color Palette Base Red with 20% opacity black*/ "120": "var(--hd-color-palette-red-120)",
                /** Color Palette Base Red with 30% opacity black*/ "130": "var(--hd-color-palette-red-130)",
                /** Color Palette Base Red with 40% opacity black*/ "140": "var(--hd-color-palette-red-140)",
                /** Color Palette Base Red with 50% opacity black*/ "150": "var(--hd-color-palette-red-150)"
            },
            "white": {
                /** Color Palette White*/ "100": "var(--hd-color-palette-white-100)"
            },
            "yellow": {
                /** Color Palette Base Yellow at 5% opacity on white*/ "5": "var(--hd-color-palette-yellow-5)",
                /** Color Palette Base Yellow at 10% opacity on white*/ "10": "var(--hd-color-palette-yellow-10)",
                /** Color Palette Base Yellow at 20% opacity on white*/ "20": "var(--hd-color-palette-yellow-20)",
                /** Color Palette Base Yellow at 30% opacity on white*/ "30": "var(--hd-color-palette-yellow-30)",
                /** Color Palette Base Yellow at 40% opacity on white*/ "40": "var(--hd-color-palette-yellow-40)",
                /** Color Palette Base Yellow at 50% opacity on white*/ "50": "var(--hd-color-palette-yellow-50)",
                /** Color Palette Base Yellow at 60% opacity on white*/ "60": "var(--hd-color-palette-yellow-60)",
                /** Color Palette Base Yellow at 70% opacity on white*/ "70": "var(--hd-color-palette-yellow-70)",
                /** Color Palette Base Yellow at 80% opacity on white*/ "80": "var(--hd-color-palette-yellow-80)",
                /** Color Palette Base Yellow at 90% opacity on white*/ "90": "var(--hd-color-palette-yellow-90)",
                /** Color Palette Base Yellow*/ "100": "var(--hd-color-palette-yellow-100)",
                /** Color Palette Base Yellow with 10% opacity black*/ "110": "var(--hd-color-palette-yellow-110)",
                /** Color Palette Base Yellow with 20% opacity black*/ "120": "var(--hd-color-palette-yellow-120)",
                /** Color Palette Base Yellow with 30% opacity black*/ "130": "var(--hd-color-palette-yellow-130)",
                /** Color Palette Base Yellow with 40% opacity black*/ "140": "var(--hd-color-palette-yellow-140)",
                /** Color Palette Base Yellow with 50% opacity black*/ "150": "var(--hd-color-palette-yellow-150)"
            }
        },
        "status": {
            "info": {
                /** Communicates informative non-critical content. The content in information alerts does not have to be actioned by users.*/ "default": "var(--hd-color-status-info)",
                /** Weak info status color, can be used for backgrounds or other non-highlight usages.*/ "weak": "var(--hd-color-status-info-weak)"
            },
            "success": {
                /** Communicates successful actions. The content in information alerts does not have to be actioned by users.*/ "default": "var(--hd-color-status-success)",
                /** Weak success status color, can be used for backgrounds or other non-highlight usages.*/ "weak": "var(--hd-color-status-success-weak)"
            },
            "warning": {
                /** Communicates important actions that users have to complete in order to proceed, or non-critical impacts to workflow.*/ "default": "var(--hd-color-status-warning)",
                /** Weak success status color, can be used for backgrounds or other non-highlight usages.*/ "weak": "var(--hd-color-status-warning-weak)"
            },
            "error": {
                /** Communicates a critical problem where users cannot proceed, or a failure has occurred in workflow.*/ "default": "var(--hd-color-status-error)",
                /** Weak error status color, can be used for backgrounds or other non-highlight usages.*/ "weak": "var(--hd-color-status-error-weak)"
            }
        },
        "text": {
            /** Default text color, used throughout UI.*/ "default": "var(--hd-color-text)",
            /** Weak text color, used for secondary informational text such as headers.*/ "weak": "var(--hd-color-text-weak)",
            /** For text displayed on accent color.*/ "on-accent": "var(--hd-color-text-on-accent)"
        }
    },
    "font": {
        "family": {
            /** Base Brand font*/ "default": "var(--hd-font-family)",
            /** Fallback from base font family.*/ "fallback": "var(--hd-font-family-fallback)"
        },
        "line-height": {
            /** Default line height for most text.*/ "default": "var(--hd-font-line-height)",
            /** Default line height for captions, hints and form errors.*/ "caption": "var(--hd-font-line-height-caption)",
            /** This is the default line height for form inputs, textareas and buttons.*/ "form": "var(--hd-font-line-height-form)",
            /** Default line height for headings.*/ "heading": "var(--hd-font-line-height-heading)",
            /** Used when line heights are compressed and don't take any extra space.*/ "tight": "var(--hd-font-line-height-tight)"
        },
        "size": {
            /** Smaller font size, default size for most text. Used for headings, plain text and component text.*/ "default": "var(--hd-font-size)",
            /** Extra Small font size, used for headings, plain text and component text.*/ "xs": "var(--hd-font-size-xs)",
            /** Smaller font size, default size for most text. Used for headings, plain text and component text.*/ "sm": "var(--hd-font-size-sm)",
            /** Medium font size, used for headings, plain text and component text.*/ "md": "var(--hd-font-size-md)",
            /** Large font size, used for headings, plain text and component text.*/ "lg": "var(--hd-font-size-lg)",
            /** Extra Large font size, used for headings, plain text and component text.*/ "xl": "var(--hd-font-size-xl)",
            /** Extra Extra Large font size, used for headings, plain text and component text.*/ "xxl": "var(--hd-font-size-xxl)"
        },
        "weight": {
            /** Default font weight for body text.*/ "default": "var(--hd-font-weight)",
            /** Default font weight for body text.*/ "regular": "var(--hd-font-weight-regular)",
            /** Default font weight for active items.*/ "active": "var(--hd-font-weight-active)",
            /** Default font weight for headings.*/ "heading": "var(--hd-font-weight-heading)",
            /** Default font weight for emphasis text.*/ "strong": "var(--hd-font-weight-strong)"
        }
    },
    "size": {
        "border-radius": {
            /** Small border radius.*/ "sm": "var(--hd-size-border-radius-sm)",
            /** Default border radius.*/ "md": "var(--hd-size-border-radius-md)",
            /** Large border radius.*/ "lg": "var(--hd-size-border-radius-lg)",
            /** Extra Large border radius.*/ "xl": "var(--hd-size-border-radius-xl)",
            /** Used for creating rounded items, such as an Avatar.*/ "circle": "var(--hd-size-border-radius-circle)",
            /** This is for creating pill shaped tags, rounded buttons .etc.*/ "pill": "var(--hd-size-border-radius-pill)"
        },
        "space": {
            /** Extra Small spacing size, used for padding, gaps, margins on elements.*/ "xs": "var(--hd-size-space-xs)",
            /** Small spacing size, used for padding, gaps, margins on elements.*/ "sm": "var(--hd-size-space-sm)",
            /** Medium spacing size, used for padding, gaps, margins on elements.*/ "md": "var(--hd-size-space-md)",
            /** Large spacing size, used for padding, gaps, margins on elements.*/ "lg": "var(--hd-size-space-lg)",
            /** Extra Large spacing size, used for padding, gaps, margins on elements.*/ "xl": "var(--hd-size-space-xl)",
            /** Extra Extra Large spacing size, used for padding, gaps, margins on elements.*/ "xxl": "var(--hd-size-space-xxl)"
        }
    },
    "layer": {
        /** A layer is defined by its starting z-index. Layers are necessary to ensure that floating elements appear with the correct overlaps - it is important to assign dynamically displayed content to the correct layer so that it appears to stack in a way that the user expects.*/ "z-index": {
            /** Elements that require a local stacking context*/ "default": "var(--hd-layer-z-index)",
            /** Elements that need to be displayed underneath a masking layer, eg. scrolling content within a Table*/ "masked": "var(--hd-layer-z-index-masked)",
            /** Elements that cover nearby neighbours, eg. the static columns of a Table*/ "mask": "var(--hd-layer-z-index-mask)",
            /** Sticky elements, eg. the headers of a Table*/ "sticky": "var(--hd-layer-z-index-sticky)",
            /** Main navigation elements, intended primarily for the top navbar of the application*/ "nav": "var(--hd-layer-z-index-nav)",
            /** Overlays that appear to obscure main content when popups and modals are shown*/ "overlay": "var(--hd-layer-z-index-overlay)",
            /** Elements shown on an overlay while awaiting its main content*/ "loader": "var(--hd-layer-z-index-loader)",
            /** Elements that appear in dropdown menus, etc*/ "popout": "var(--hd-layer-z-index-popout)",
            /** Elements that appear in response to user actions*/ "toast": "var(--hd-layer-z-index-toast)",
            /** Elements that demand user interaction by blocking out other parts of the page*/ "modal": "var(--hd-layer-z-index-modal)"
        }
    }
};
const getVariableName = (token)=>{
    return token.replace("var(", "").replace(")", "");
};

export { getVariableName, tokens };
